export default __webpack_public_path__ + "static/media/e-learning.b09d37c4.png";